export const Marquee = () => {
    const items = [
        "Webdesign",
        "Strategie",
        "UX/UI",
        "Corporate Websites",
        "Digitale Präsenz",
        "Consulting",
        "Rebranding",
        "Performance",
    ];
    const track = [...items, ...items];
    return (
        <div
            className="border-y border-ls-ink/10 py-6 overflow-hidden bg-ls-bg"
            data-testid="marquee"
        >
            <div className="marquee-track">
                {track.map((t, i) => (
                    <div
                        key={i}
                        className="flex items-center gap-8 pr-8 font-serif text-3xl md:text-5xl text-ls-ink/85 whitespace-nowrap"
                    >
                        <span>{t}</span>
                        <span className="inline-block w-2 h-2 rounded-full bg-ls-ink/50" />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Marquee;
